import React, { useState, useEffect } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, Spinner } from "react-bootstrap";
import { getAffiliatedPersonDetails } from "../actions";
import Maintenance from "../../Maintenance";

/*** 
@purpose : Functional Component
@Parameter : {props}
**/
function AffiliatedPersonnel(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [details, setDetails] = useState([]);
  const [data, setData] = useState({});
  const [limit, setLimit] = useState(40);
  const [loading, setLoading] = useState(true);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [orgId, setOrgId] = useState();
  const [total, setTotal] = useState(0);

  const [af, setAF] = useState("asc");
  const [jtn, setJTN] = useState("asc");
  const [jtl, setJTL] = useState("asc");
  const [ucc, setUCC] = useState("asc");
  const [ctnl, setCTNL] = useState("asc");
  const [gy, setGY] = useState("asc");
  const [unl, setUNL] = useState("asc");


  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "/organizationCustomer",
    },
    {
      name: `${lang("organizationDetails.organizationCustomerDetails")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchData() {
      let body = {
        id: props.id,
        limit: 0,
        totalRecords: 0,
      };
      setOrgId(props.id);

      try {
        const res = await getAffiliatedPersonDetails(body);
        // if (res.maintenanceWindowFlag) {
        //   setMaintenance(true);
        // } else {
        setDetails(res && res.data && res.data.affiliatedPerson);
        setTotal(
          res &&
          res.data.affiliatedPerson &&
          res.data.affiliatedPerson[0] &&
          res.data.affiliatedPerson[0].total
        );
        // }
      } catch (error) {
        console.error("Error fetching affiliated person details:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const changeRoute = (e, page) => {
    let id = unescape(page).split("?personId=")[1];

    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  const goToPerson = (id) => {
    navigate(`/personInfo?personId=${id}`);
  };

  // /*** 
  // @purpose : Lazyload function
  // @Parameter : {}
  // **/
  // const handleContainerOnBottom = async () => {
  //   let body = {
  //     id: orgId,
  //     limit: details.length,
  //     totalRecords: total,
  //   };
  //   if (details.length <= total && total >= 30) {
  //     await getAffiliatedPersonDetails(body).then((response) => {
  //       let list = [];
  //       list = details.concat(response.data.affiliatedPerson);
  //       setDetails(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  const loadRecords = async () => {
    let body = {
      id: orgId,
      limit: details.length,
      totalRecords: total,
    };
    if (details.length < total) {
      try {
        setLazyLoading(true);
        const response = await getAffiliatedPersonDetails(body);
        let list = details.concat(response.data.affiliatedPerson);
        setDetails(list);
        setLimit(limit + 10);
      } catch (error) {
        console.error("Error loading more records:", error);
      } finally {
        setLazyLoading(false);
      }
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  /*** 
@purpose : Handle sorting
@Parameter : {}
**/
  const handleSortingData = (obj) => {
    obj.column === "affiliatedDepartmentName" && setAF(obj.sortOrder);
    obj.column === "jobTitleName" && setJTN(obj.sortOrder);
    obj.column === "jobTitleLocal" && setJTL(obj.sortOrder);
    obj.column === "unifiedCustomerCode" && setUCC(obj.sortOrder);
    obj.column === "customerTypeNameLocal" && setCTNL(obj.sortOrder);
    obj.column === "graduatedYear" && setGY(obj.sortOrder);
    obj.column === "universityNameLocal" && setUNL(obj.sortOrder);
    let list = compareBySortedData(obj);
    setDetails(list);
  };

  /*** 
@purpose : Compare sorted data
@Parameter : {}
**/
  const compareBySortedData = (obj) => {
    const sorted = details.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  return (
    <>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <div className="org-main">
          <div className="org-wrapper1">
            <h4 className="primary-title">
              {lang("OrganizationMenu.affiliatedPersonnel")}
            </h4>
            {details && details.length > 0 && (
              <p className="record-total">
                {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                {details && details.length} / {total}
              </p>
            )}
            {details && details.length > 0 && (
              <>
                <div
                  // ref={containerRef}
                  // onBottom={handleContainerOnBottom}
                  className="table-responsive mb-0 max-height hover-table"
                >
                  <table className="table" aria-describedby="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "affiliatedDepartmentName",
                              sortOrder: af === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("organizationDetails.affiliatedDepartment")}
                            <em class="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "jobTitleName",
                              sortOrder: jtn === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("organizationDetails.jobTitle")}
                            <em class="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "unifiedCustomerCode",
                              sortOrder: ucc === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("organizationDetails.customerName")}
                            <em class="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "customerTypeNameLocal",
                              sortOrder: ctnl === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("organizationDetails.customerType")}
                            <em class="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "graduatedYear",
                              sortOrder: gy === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("PersonMenu.graduatedYear")}
                            <em class="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "universityNameLocal",
                              sortOrder: unl === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("PersonMenu.graduatedUniversity")}
                            <em class="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {details &&
                        details.map((org,index) => {
                          return (
                            org && (
                              <tr
                                key={index}
                                onClick={() => goToPerson(org.personCustomerId)}
                              >
                                <td>
                                  {org && org.affiliatedDepartmentName
                                    ? org.affiliatedDepartmentName
                                    : ""}
                                </td>
                                <td>
                                  {org && org.jobTitleName
                                    ? org.jobTitleName
                                    : "" + " " + org.jobTitleLocal
                                      ? org.jobTitleLocal
                                      : ""}
                                </td>
                                <td>
                                  {/*                                {(org && org.legacyUnifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                  {/*                                  ? org.legacyUnifiedCustomerCode       /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                  {(org && org.unifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    ? org.unifiedCustomerCode       /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    : "") +
                                    "  " +
                                    (org.customerNameLocal
                                      ? org.customerNameLocal
                                      : "")}
                                </td>
                                <td>
                                  {org && org.customerTypeNameLocal
                                    ? org.customerTypeNameLocal
                                    : ""}
                                </td>
                                <td>
                                  {org && org.graduatedYear
                                    ? org.graduatedYear
                                    : ""}
                                </td>
                                <td>
                                  {org && org.universityNameLocal
                                    ? org.universityNameLocal
                                    : ""}
                                </td>
                              </tr>
                            )
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                {details.length < total && <div className="steps-action1 mt-4">
                  {lazyLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={loadRecords}
                    disabled={lazyLoading}
                  >
                    {lang("Buttons.loadMore")}
                  </button>
                </div>}
              </>
            )}
          </div>
        </div>
      )}
      <Modal
        size="md"
        className="withdraw-modal"
        show={customerNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.CUSTOMER_NOT_FOUND")}
          </div>
          <p className="mb-3">
            {lang("errorMessages.SEARCH_REQUESTS")}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/organizationCustomer");
              }}
            >
              {lang("Menu.organizationCustomer")}
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AffiliatedPersonnel;
